module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/staff-onuma-9582e01f18d5d682d8e3beec8883a664.webp";